import { render, staticRenderFns } from "./FaceHandsLab.vue?vue&type=template&id=8bc199c0&scoped=true"
import script from "./FaceHandsLab.vue?vue&type=script&lang=js"
export * from "./FaceHandsLab.vue?vue&type=script&lang=js"
import style0 from "./FaceHandsLab.vue?vue&type=style&index=0&id=8bc199c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc199c0",
  null
  
)

export default component.exports